import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoimagicacab() {



  const cardData =
  {
    keyword: 'Mumbai to Imagica Cab ',
    heading: 'Shambhu Cabs: Mumbai to Imagica Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Imagica Cab services, providing safe, comfortable, and hassle-free travel for families, friends, and groups planning a fun-filled day at the popular Imagica Theme Park. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Imagica with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip convenient, stress-free, and enjoyable. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Imagica cab services for travelers seeking comfort, safety, and a memorable travel experience.',

    top: 'Top Places to Visit in Imagica with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Nitro Roller Coaster",
    "description": "Nitro is one of Imagica’s most thrilling attractions, offering high-speed roller coaster excitement. With sudden drops, twists, and turns, it provides an adrenaline rush suitable for adventure enthusiasts. The coaster is surrounded by vibrant park landscapes and themed décor, making the ride both visually and physically exhilarating. Nitro is a must-try for visitors seeking extreme thrills at Imagica."
  },
  {
    "title": "Deep Space",
    "description": "Deep Space is a 4D interactive dark ride that takes visitors on a space adventure filled with cosmic visuals, laser guns, and special effects. Riders experience a journey across galaxies, shooting targets and engaging with animated characters. The combination of motion, 3D effects, and storytelling makes Deep Space a unique and immersive experience for all age groups."
  },
  {
    "title": "Scream Machine",
    "description": "Scream Machine is a giant pendulum ride that swings visitors high into the air while spinning rapidly. The ride provides stunning aerial views of Imagica Park and its surroundings while delivering a thrilling mix of excitement and suspense. With adrenaline-pumping swings and a safe yet intense ride mechanism, it is one of the park’s top attractions for thrill-seekers."
  },
  {
    "title": "Dynamo",
    "description": "Dynamo is an intense spinning ride that flips, rotates, and spins visitors in all directions, offering a high-adrenaline experience. The ride is designed for those seeking extreme thrills, with quick rotations, sudden drops, and synchronized spins that create an unforgettable roller-coaster-style adventure. It is one of Imagica’s most exhilarating rides for adventurous guests."
  },
  {
    "title": "Imagica Water Park",
    "description": "Imagica Water Park is a separate section offering slides, wave pools, lazy rivers, and water-based attractions for families and thrill-seekers alike. With dedicated zones for kids, families, and adults, it provides fun-filled aquatic entertainment. Attractions include high-speed water slides, splash zones, and tropical-themed pools, making it a perfect place to cool off on hot days while enjoying water-based adventure."
  },
  {
    "title": "Mr. India Attraction",
    "description": "Inspired by the famous Bollywood movie, Mr. India is an immersive ride featuring dark ride storytelling, animatronics, and visual effects. Guests experience a journey through iconic scenes of the film, interacting with characters and overcoming challenges. The ride blends entertainment, nostalgia, and innovative technology, making it an engaging experience for families and film enthusiasts alike."
  },
  {
    "title": "Rajasaurus River Adventure",
    "description": "Rajasaurus River Adventure is a water-based ride combining gentle rapids with life-sized animatronic dinosaurs. Visitors embark on a thrilling river journey encountering prehistoric creatures in themed environments. The ride balances adventure and family-friendly fun, providing an educational glimpse into the dinosaur era while delivering excitement for all ages."
  },
  {
    "title": "Adventure Sports Zone",
    "description": "Imagica’s Adventure Sports Zone offers rock climbing, bungee jumping, zip-lining, and other outdoor adventure activities. It caters to adrenaline seekers looking for physical challenges beyond amusement rides. With professional safety measures, trained staff, and engaging obstacle courses, this zone provides both thrill and skill-building opportunities in an open-air environment."
  },
  {
    "title": "Imagica Express Train",
    "description": "The Imagica Express is a scenic train ride that takes visitors around the entire park, offering panoramic views of attractions, gardens, and themed zones. It is perfect for families and those who want a relaxed tour of the park. Along the route, guests can enjoy themed décor, musical performances, and photo opportunities, making it a fun and leisurely experience."
  },
  {
    "title": "Food and Entertainment Plaza",
    "description": "Imagica offers a variety of food courts, cafes, and restaurants serving Indian, continental, and international cuisines. The entertainment plaza hosts live performances, street shows, and cultural events throughout the day. Visitors can enjoy meals, snacks, and beverages while immersing themselves in lively music, performances, and the vibrant atmosphere of the park, creating a holistic theme park experience."
  }
],




"services": [
  {
    "name": "Mumbai Imagica Taxi",
    "description": "Mumbai Imagica Taxi provides convenient and reliable transportation for travelers heading to Imagica Adlabs from Mumbai. Ideal for families, groups, and solo travelers, this service ensures timely pickups, professional drivers, and well-maintained vehicles for a smooth and enjoyable journey to the theme park. With flexible booking options, passengers can enjoy a stress-free trip and avoid the hassle of parking or traffic."
  },
  {
    "name": "Imagica Adlabs Cab Mumbai",
    "description": "Imagica Adlabs Cab Mumbai offers a dedicated service for visitors planning a fun-filled day at the Imagica theme park. Passengers benefit from safe and comfortable travel, experienced chauffeurs familiar with the best routes, and multiple vehicle choices including SUVs and sedans for groups or families."
  },
  {
    "name": "One-Way Cab Mumbai Imagica",
    "description": "One-Way Cab Mumbai Imagica is perfect for travelers seeking single-direction service to the theme park. This option is ideal for day trips, family outings, or short visits, offering economical pricing, timely pickups, and hassle-free travel without the need for a return booking."
  },
  {
    "name": "Affordable Imagica Cab Mumbai",
    "description": "Affordable Imagica Cab Mumbai provides budget-friendly transportation to Imagica without compromising on comfort or safety. Passengers can enjoy transparent pricing, clean and well-maintained vehicles, and professional drivers experienced in long-distance highway travel."
  },
  {
    "name": "Best Taxi Mumbai Imagica",
    "description": "Best Taxi Mumbai Imagica is known for its high-quality vehicles, punctual service, and professional chauffeurs. This premium cab service ensures a comfortable and enjoyable ride for individuals, families, and groups traveling to the Imagica theme park from Mumbai."
  },
  {
    "name": "SUV Cab Mumbai Imagica",
    "description": "SUV Cab Mumbai Imagica provides spacious and comfortable vehicles suitable for family trips or group outings. Equipped with modern amenities and safety features, SUVs ensure a smooth journey even on longer routes to the theme park."
  },
  {
    "name": "Sedan Cab Mumbai Imagica",
    "description": "Sedan Cab Mumbai Imagica offers elegant and comfortable sedans for travelers seeking a smooth and economical ride to Imagica. Ideal for couples or small families, these sedans provide a reliable, air-conditioned, and safe travel experience."
  },
  {
    "name": "24×7 Mumbai Imagica Cab",
    "description": "24×7 Mumbai Imagica Cab guarantees round-the-clock availability for pickups and drop-offs. Passengers arriving at different times or planning early morning trips can rely on punctual service, professional drivers, and uninterrupted travel options."
  },
  {
    "name": "Family Cab Mumbai Imagica",
    "description": "Family Cab Mumbai Imagica is tailored for families traveling together to Imagica. With spacious seating, ample luggage space, and a focus on safety, this service ensures a relaxed and enjoyable journey suitable for children and adults alike."
  },
  {
    "name": "Corporate Cab Mumbai Imagica",
    "description": "Corporate Cab Mumbai Imagica offers professional and timely transportation for business groups or corporate outings to Imagica. The service includes premium vehicles, experienced chauffeurs, and flexible scheduling to meet corporate standards."
  },
  {
    "name": "Fast Cab Mumbai Imagica",
    "description": "Fast Cab Mumbai Imagica ensures efficient travel with optimized highway routes, experienced drivers, and minimal delays. Passengers can enjoy a swift and comfortable journey to Imagica without any stress or traffic concerns."
  },
  {
    "name": "Premium Imagica Cab",
    "description": "Premium Imagica Cab offers high-end sedans and SUVs with luxury interiors for travelers who prefer a more comfortable and stylish ride. Ideal for VIP passengers or special occasions, this service provides an exceptional travel experience from Mumbai to Imagica."
  },
  {
    "name": "Safe Taxi Mumbai Imagica",
    "description": "Safe Taxi Mumbai Imagica focuses on passenger safety with trained chauffeurs, GPS-enabled vehicles, and adherence to traffic rules. Families, solo travelers, and senior citizens can rely on a secure and worry-free trip to the theme park."
  },
  {
    "name": "Mumbai Imagica Pickup Drop",
    "description": "Mumbai Imagica Pickup Drop provides seamless door-to-door service from any location in Mumbai to the Imagica theme park. With flexible scheduling, professional drivers, and reliable vehicles, passengers can enjoy a convenient and hassle-free ride."
  },
  {
    "name": "Express Highway Cab Imagica",
    "description": "Express Highway Cab Imagica ensures a fast and smooth ride using the Mumbai-Pune Expressway for quick access to the theme park. Passengers benefit from comfortable vehicles, skilled drivers, and minimal travel time on scenic routes."
  },
  {
    "name": "Mumbai to Khopoli Cab",
    "description": "Mumbai to Khopoli Cab offers specialized transport to the Khopoli area near Imagica. Ideal for travelers staying near Khopoli or planning to visit local attractions, this service ensures timely pickups, safe travel, and convenient vehicle options."
  },
  {
    "name": "Imagica Theme Park Cab Mumbai",
    "description": "Imagica Theme Park Cab Mumbai provides direct and dedicated transfers to the theme park for day trips, family outings, and group visits. With flexible vehicle options, professional chauffeurs, and transparent pricing, passengers enjoy a smooth and enjoyable experience from Mumbai."
  }
],

"tableData": [
  ["Mumbai Imagica Taxi", "Imagica Adlabs Cab Mumbai"],
  ["One-Way Cab Mumbai Imagica", "Affordable Imagica Cab Mumbai"],
  ["Best Taxi Mumbai Imagica", "SUV Cab Mumbai Imagica"],
  ["Sedan Cab Mumbai Imagica", "24×7 Mumbai Imagica Cab"],
  ["Family Cab Mumbai Imagica", "Corporate Cab Mumbai Imagica"],
  ["Fast Cab Mumbai Imagica", "Premium Imagica Cab"],
  ["Safe Taxi Mumbai Imagica", "Mumbai Imagica Pickup Drop"],
  ["Express Highway Cab Imagica", "Mumbai to Khopoli Cab"],
  ["Imagica Theme Park Cab Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Imagica Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai to Imagica cab services, perfect for theme park visits, weekend trips, and family outings."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and enjoyable ride from Mumbai to Imagica."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Highway and Short Trips",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Imagica route, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Imagica cab trip stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Short and Day Trips",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental options to suit your Mumbai to Imagica travel plans."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Imagica journey comfortable and worry-free."
  }
]































  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Imagica cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable cab services from Mumbai to Imagica, ensuring a smooth and enjoyable journey.',
  },
  {
    question: 'How can I book a Mumbai to Imagica cab with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for hassle-free booking.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Imagica cab bookings?',
    answer: 'Shambhu Cabs offers sedans, SUVs, and premium cars suitable for family trips, group outings, and leisure travel to Imagica.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Imagica route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mumbai to Imagica route to ensure a safe and comfortable ride.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Imagica cab?',
    answer: 'Absolutely. You can choose any pickup point in Mumbai and select your preferred drop-off location at Imagica.',
  },
  {
    question: 'Is the Mumbai to Imagica cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock cab services from Mumbai to Imagica to match your travel plans.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai to Imagica cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict hygiene and safety measures to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Imagica cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Imagica journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Imagica trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Our Mumbai to Imagica trip with Shambhu Cabs was seamless. The driver was punctual, and the ride was very comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Mehta',
    feedback: 'Highly recommended for family trips! Clean car, professional driver, and timely service from Mumbai to Imagica.',
    rating: 5,
  },
];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Imagica Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-imagica-cab.jpg",
  "description": "Shambhu Cabs provides safe, reliable, and affordable Mumbai to Imagica cab services for one-way trips and family outings. Book sedans, SUVs, or premium cars for corporate travel, fast trips, and highway journeys. Available 24×7 with convenient pickup-drop, including Mumbai to Khopoli and Imagica Theme Park transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-imagica-cab"
  }
};





  return (
    <div>
      <Helmet>
  <title>Mumbai to Imagica Cab | Outstation & Corporate Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Imagica cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for one-way trips, family outings, corporate travel, and highway journeys. Available 24×7 with sedans, SUVs, and premium cars, including pickup-drop to Khopoli and Imagica Theme Park."
  />

  <meta
    name="keywords"
    content="Mumbai Imagica Taxi, Imagica Adlabs Cab Mumbai, One-Way Cab Mumbai Imagica, Affordable Imagica Cab Mumbai, Best Taxi Mumbai Imagica, SUV Cab Mumbai Imagica, Sedan Cab Mumbai Imagica, 24×7 Mumbai Imagica Cab, Family Cab Mumbai Imagica, Corporate Cab Mumbai Imagica, Fast Cab Mumbai Imagica, Premium Imagica Cab, Safe Taxi Mumbai Imagica, Mumbai Imagica Pickup Drop, Express Highway Cab Imagica, Mumbai to Khopoli Cab, Imagica Theme Park Cab Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoimagicacab;